
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import FooterRepository from '@/repositories/content/FooterRepository';
import FooterLinkRepository from '@/repositories/content/FooterLinkRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class FooterFormScreen extends Vue {
    @Inject()
    private readonly footerRepository!: FooterRepository;

    @Inject()
    private readonly footerLinkRepository!: FooterLinkRepository;

    public get embeds() {
        return [
            {
                relationship: 'links',
                parentRefKey: 'footerId',
                i18nGroup: 'footerLink',
                entityRepository: this.footerLinkRepository,
                columns: ['textNl', 'textEn'],
            },
        ];
    }
}
